export const useHeaderLogic = (t) => {
  const getCurrentHeader = (currentGroup, belongsTo, createModal) => {
    if (typeof currentGroup !== 'undefined' && currentGroup !== null) {
      let cgCopy = { ...currentGroup, belongsTo: belongsTo };
      delete cgCopy.modifiers;
      delete cgCopy.products;
      return cgCopy;
    } else {
      return {
        name: '',
        createdAt: null,
        isActive: false,
        inheritModifiers: createModal && belongsTo ? true : false,
        isSecured: false,
        accessKey: '',
        category: '',
        belongsTo: belongsTo,
        modifierTemplate: null
      };
    }
  };

  const getGroupType = (header) => {
    if (header.belongsTo) {
      if (header.name === t('common.groupPhotos')) {
        return t('common.groupPhotos');
      } else {
        return t('common.class');
      }
    } else {
      return t('common.school');
    }
  };

  return {
    getCurrentHeader,
    getGroupType
  };
};
